
const base = {

    baseUrl: "https://backend.arcnix.com",//生产模式
    //baseUrl: "https://localhost:44388",//开发模式

    avatarbaseurl: "/uploads/",

    loginPoint: "/api/AdminUser/login",

    //AdminNews
    getNewsTypePoint: "/api/AdminNews/getnewstype",
    getAllNewsTypePoint: "/api/AdminNews/getAllnewstype",
    postNewNewsTypePoint: "/api/AdminNews/addnewstype",
    putNewsTypePoint: "/api/AdminNews/mdfnewstype/",
    delNewsTypePoint: "/api/AdminNews/delnewstype/",
    getNewsListPoint: "/api/AdminNews/getnews",
    getNewsByIDPoint: "/api/AdminNews/getnewsby/",
    putNewsByIDPoint: "/api/AdminNews/updatenews",
    postAddNewsPoint: "/api/AdminNews/addnews",
    deleteNewsPoint: "/api/AdminNews/delnews",

    //AdminOpenSource
    getOpenSourceTypePoint: "/api/AdminOpenSource/getopensourcetype",
    getAllOpenSourceTypePoint: "/api/AdminOpenSource/getAllopensourcetype",
    postNewOpenSourceTypePoint: "/api/AdminOpenSource/addopensourcetype",
    putOpenSourceTypePoint: "/api/AdminOpenSource/mdfopensourcetype/",
    delOpenSourceTypePoint: "/api/AdminOpenSource/delopensourcetype/",
    getOpenSourceListPoint: "/api/AdminOpenSource/getopensourceinfo",
    getOpenSourceInfoByIDPoint: "/api/AdminOpenSource/getopensourceby/",
    putOpenSourceInfoByIDPoint: "/api/AdminOpenSource/updateopensource",
    postAddOpenSourcePoint: "/api/AdminOpenSource/addopensource",
    deleteOpenSourcePoint: "/api/AdminOpenSource/delopensource",

    //AdminHelp
    getHelpTypePoint: "/api/AdminHelp/gethelptype",
    getAllHelpTypePoint: "/api/AdminHelp/getAllhelptype",
    postAddHelpTypePoint: "/api/AdminHelp/addhelptype",
    putUpdateHelpTypePoint: "/api/AdminHelp/mdfhelptype/",
    deleteHelpTypePoint: "/api/AdminHelp/delhelptype/",
    getHelpListPoint: "/api/AdminHelp/gethelplist",
    getHelpInfoPoint: "/api/AdminHelp/gethelpinfoby/",
    putUpdateHelpInfoPoint: "/api/AdminHelp/updatehelpinfo",
    postAddHelpInfoPoint: "/api/AdminHelp/addhelpinfo",
    deleteHelpInfoPoint: "/api/AdminHelp/delhelpinfo",

    //AdminOrder
    getOrderTypePoint: "/api/AdminOrder/getordertype",
    getAllOrderTypePoint: "/api/AdminOrder/getAllordertype",
    postAddOrderTypePoint: "/api/AdminOrder/addordertype",
    putUpdateOrderTypePoint: "/api/AdminOrder/mdfordertype/",
    deleteOrderTypePoint: "/api/AdminOrder/delordertype/",
    getOrderListPoint: "/api/AdminOrder/getorderlist",
    getOrderInfoPoint: "/api/AdminOrder/getorderinfoby/",
    putUpdateOrderInfoPoint: "/api/AdminOrder/updateorderinfo",
    postAddOrderInfoPoint: "/api/AdminOrder/addorderinfo",
    deleteOrderInfoPoint: "/api/AdminOrder/delorderinfo",

    getUserOrderListPoint: "/api/AdminUserOrder/getuserorderlist",
    getUserOrderInfoPoint: "/api/AdminUserOrder/getuserorderinfoby/",
    postReUserOrderInfoPoint: "/api/AdminUserOrder/reuserorder",
    putUpdateUserOrderStatusPoint: "/api/AdminUserOrder/updateuserorderstatus",
    getSimpleUserOrderInfoPoint: "/api/AdminUserOrder/getsimpleuserorderinfoby/",
 


}



export default base;